import { Injectable } from '@angular/core';

export interface BlockServiceLabels {
  ethChannelConnectionError: string;
  mqttChannelConnectionError: string;
  deviceNotFoundError: string;
  requestFailedError: string;
  loggerNotFoundError: string;
  ahChannelConnectionError: string;
  genericErrorMessage: string;

  // Bluetooth keys
  bluetoothEnableRequired: string;
  bluetoothRetryAfterEnable: string;
  bluetoothOpenSettings: string;
  bluetoothLocationRequired: string;
  bluetoothEnableLocationForBluetooth: string;
  bluetoothUnableToScan: string;

  // Common keys
  commonCancel: string;
  commonError: string;
  commonRetry: string;
  commonUnsupportedStickLogger: string;
  commonWaits: string;
  commonUnableToOpenSocket: string;
  commonUpdatingSystemConfiguration: string;

  // Device Info keys
  deviceInfoBattery: (params: { value: number }) => string;
}

export const blockServiceLabels: BlockServiceLabels = {
  ethChannelConnectionError: 'Cant connect to logger with ethernet channel',
  ahChannelConnectionError: 'Cant connect to Azzurro Hub channel',
  deviceNotFoundError: 'Device not found',
  requestFailedError: 'Request failed',
  loggerNotFoundError: 'Logger not found',
  genericErrorMessage: 'Sorry, something went wrong',
  mqttChannelConnectionError: 'Cant connect to logger with mqtt channel',

  // Bluetooth keys
  bluetoothEnableRequired: 'Enable Bluetooth is required',
  bluetoothRetryAfterEnable: 'Retry after enable Bluetooth',
  bluetoothOpenSettings: 'Open settings',
  bluetoothLocationRequired: 'Location required',
  bluetoothEnableLocationForBluetooth: 'Location services are required to use Bluetooth on Android',
  bluetoothUnableToScan: 'Unable to start Bluetooth scan',

  // Common keys
  commonCancel: 'Cancel',
  commonError: 'Error',
  commonRetry: 'Retry',
  commonUnsupportedStickLogger: 'Unsupported stick logger',
  commonWaits: 'Wait',
  commonUnableToOpenSocket: 'Unable to open socket',
  commonUpdatingSystemConfiguration: 'Updating system configuration',

  // Device Info keys
  deviceInfoBattery: (params: { value: number }) => `Battery ${params.value}`,
};

@Injectable({
  providedIn: 'root',
})
export class BlockTranslationsService {

  get labels(): BlockServiceLabels {
    return blockServiceLabels;
  }

  updateLabels(labels: Partial<BlockServiceLabels>): void {
    Object.assign(blockServiceLabels, labels);
  }
}
